import React from 'react'

import { P } from '@mxenabled/mxui'

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'

interface PulseGraidentBoxProps {
  children: React.ReactNode
  gradientOverride?: string
  title: string
}

export const PulseGraidentBox: React.FC<PulseGraidentBoxProps> = ({
  children,
  gradientOverride,
  title,
}) => {
  return (
    <Box
      className="mx-insights-gradient-box"
      data-ui-test="gradient-box"
      sx={{
        background: !gradientOverride ? 'linear-gradient(#2F73DA, #6BCDDB)' : gradientOverride,
        p: 16,
      }}
    >
      {title && (
        <P
          className="mx-insights-gradient-box-title"
          data-ui-test="gradient-box-title"
          sx={{ color: 'primary.lighter', fontSize: 13, lineHeight: '16px', mb: 16 }}
        >
          {title}
        </P>
      )}
      <Card
        className="mx-insights-gradient-box-card"
        sx={{
          p: '12px 16px',
        }}
      >
        {children}
      </Card>
    </Box>
  )
}
